module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av676-e531bf843477d99358b88fab0f82f861.jpg";